module.exports = __webpack_public_path__ + "static/delivery-guy-78cd782b9275f8009716b0060d43e78c.gif";